import type { ReactNode } from "react";
import { Badge } from "./components";
import DataCoverageLayout from "./layout";

const rows = [
  { market: "Dow Jones Indices", historical: "Y", delayed: "Y", realTime: "A", level2: "N/A" },
  { market: "S&P Indices", historical: "Y", delayed: "A", realTime: "A", level2: "N/A" },
  { market: "CBOE Indices", historical: "N/A", delayed: "Y", realTime: "A", level2: "N/A" },
  { market: "Nasdaq Indices", historical: "Y", delayed: "Y", realTime: "A", level2: "N/A" },
  { market: "TSX Indices", historical: "Y", delayed: "Y", realTime: "A", level2: "N/A" },
  { market: "Euronext Indices", historical: "Y", delayed: "Y", realTime: "A", level2: "N/A" },
];

export default function IndicesPage(): ReactNode {
  return (
    <DataCoverageLayout>
      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
          <tr className="border-b border-gray-200">
            {["Market", "Historical", "Delayed", "Real Time", "Level 2"].map(h => (
              <th key={h} className="text-left py-2 px-3 text-xs font-semibold text-gray-500 uppercase tracking-wide whitespace-nowrap">{h}</th>
            ))}
          </tr>
          </thead>
          <tbody>
          {rows.map(({ market, historical, delayed, realTime, level2 }) => (
            <tr key={market} className="border-b border-gray-100 hover:bg-gray-50">
              <td className="py-2 px-3 font-medium text-gray-800 whitespace-nowrap">{market}</td>
              <td className="py-2 px-3"><Badge value={historical}/></td>
              <td className="py-2 px-3"><Badge value={delayed}/></td>
              <td className="py-2 px-3"><Badge value={realTime}/></td>
              <td className="py-2 px-3"><Badge value={level2}/></td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </DataCoverageLayout>
  );
}
